<template>
  <div class="questions">
    <app-qaheader custom="Din virksomhed"></app-qaheader>
    <div class="card">
      <div class="card-middle" :style="{ height: qHeight }">
        <div class="card-middle-inside" id="middle" ref="middle">
          <appBusinessInfo  />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-bottom">
        <div class="card-bottom-inside">
          <button class="btn-progress btn-prev" type="button" name="button" @click="prevPage"><span>Forrige</span></button>
          <div class="progress-bar ">
            <div class="progress-bar-inside" :style="{width: '1px' }">

            </div>
          </div>
          <div class="progress-bar-mobile">
            <div class="progress-bar-inside-mobile" style="">
              <span>1%</span>
              <div class="">
                Gennemført
              </div>
            </div>
          </div>
          <button class="btn-progress btn-next" type="button" name="button" @click="nextPage"><span>Næste </span></button>
        </div>
      </div>
    </div>
    <app-cfooter></app-cfooter>
  </div>
</template>

<script>
import qaheader from '@/components/modular/question-header.vue';
import Cfooter from '@/components/modular/cfooter.vue';
import BusinessInfo from '@/components/modular/BusinessInfo.vue';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import {db} from '@/database/firebase';
import Marked from 'marked';
import Axios from 'axios';

export default {
  name: 'Questions',
  components: {
    appQaheader: qaheader,
    appCfooter: Cfooter,
    appBusinessInfo: BusinessInfo
  },
  data () {
    return {
      page: 0,
      qHeight:'auto',
      count:1,
      next:1,
      toggle:false,
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'firm',
      'globalC',
      'spinner',
      'surveyIsActive',
      'qaNumber',
      'answers',
      'progress'
    ]),
  },
  mounted() {
    if(!this.surveyIsActive){
      this.$router.push({ path: '/survey/v2/'+ this.$route.params.survey })
    }
    this.getWidth();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapActions([
      'setNewAnswer',
      'avarage',
      'setPrev',
      'setProgress'
    ]),
    getHeight(){
      let h = this.$refs.middle
      let self = this
      if(h){
        self.qHeight = h.clientHeight+'px'
        setTimeout(function(){
          self.qHeight = h.clientHeight+'px';
          console.log(h.clientHeight);
        }, 300)
      }
    },
    getWidth(){
      let w = Number(this.count/1) * 100;
      this.setProgress(w);
    },
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    },
    nextPage(){
      let s = this.$route.params.survey;

      if (this.firm.user.permissionemail && this.firm.TDCId) {
        var postData = {
          MarketingCampaignId: this.globalC.varsEmail.MarketingCampaignId,
          email: this.firm.email,
          mdbIdentifier: this.globalC.varsEmail.mdbIdentifier,
          Datasource: this.globalC.varsEmail.Datasource,
          ProjectName: this.survey[s].name,
          TDCId: this.firm.TDCId,
          personName: this.firm.user.name,
          company: this.firm.firmName,
          street: this.firm.street,
          streetnumber: this.firm.streetnumber,
          floor: this.firm.floor,
          zipCode: this.firm.zipCode,
          city: this.firm.city,
          kundetype: this.globalC.varsEmail.kundetype,
          isCustomer: this.firm.isCustomer,
          emailpermission1_Id: this.globalC.varsEmail.emailpermission1_Id,
          emailpermission1: this.globalC.varsEmail.emailpermission1,
          phone_1: this.firm.phone,
          phonepermission1_Text: this.globalC.varsEmail.phonepermission1_Text,
          phonepermission1: this.globalC.varsEmail.phonepermission1,
          text_name1: this.globalC.varsEmail.text_name1,
          text_1: 'https://sikkerhedstjek.dk/rapport/' + s + '/' + this.firm.firmId + '',
          text_name2: this.globalC.varsEmail.text_name2,
          text_2: this.firm.cvr,
          text_name3: this.globalC.varsEmail.text_name3,
          text_3: this.firm.employees,
          text_name4: this.globalC.varsEmail.text_name4,
          text_4: this.firm.location,
          text_name5: this.globalC.varsEmail.text_name5,
          text_5: this.firm.sqm,
          text_name6: this.globalC.varsEmail.text_name6,
          text_6: 'nope',
          text_name7: "saelgerid",
          text_7: '',
          text_name8: "editguid",
          text_8: ''
        }

        //db.ref('email').child(s).child(this.firm.firmId).set(postData);

        var bodyFormData = new FormData;
        for (var k in postData) {
          if (postData.hasOwnProperty(k)) {
            bodyFormData.append(k, postData[k]);
            //bodyFormData.set(k, postData[k]);
          }
        }
        //console.log(bodyFormData);

        let axiosConfig = {
          responseType: 'json',
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        let url = 'https://mdbprodssl.falck.com/marketingform/MarketingServicePost.ashx'
        Axios.post(url, bodyFormData, axiosConfig)
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log("AXIOS ERROR: ", err);
          })
          this.$router.push({ path: '/survey/v2/'+s+'/c/0/q/0' })
      } else {
          this.$router.push({ path: '/survey/v2/'+s+'/c/0/q/0' })
      }
    },
    prevPage(){
      let s = this.$route.params.survey;
      this.$router.push({ path: '/survey/v2/'+s })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
label >>> p{
  color:#fff;
  margin: 10px 0 0;
}
.card-middle-inside{
  padding:50px 60px 30px 60px;
  width: auto;
  max-width: 800px;
  @media(max-width: 1023px){
    padding:50px 16px 0;
  }
}
.card-bottom-inside{
  display: flex;
  justify-content: center;
  align-items: center;
  height:144px;
  margin-left: 30px;
  margin-right: 30px;
  max-width: calc(100% - 60px);
}
.progress-bar-mobile{
  display: none;
  text-align: center;
  font-size: 14px;
  margin-left: auto;
  margin-right: auto;
  & span{
    font-size: 30px;
    font-weight: 500;
    position: relative;
    top: -10px;

  }
  @media(max-width: 1023px){
    display: block;
  }
}
.progress-bar{
  @media(max-width: 1023px){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/extended/extended-before-start.vue